import React from 'react';
import logo from './logo.svg';
import './App.css';
import {HashRouter as Router, Route} from 'react-router-dom';
import IndexPage from "./pages";

function App() {
    return (
        <Router>
            <Route path="/" component={IndexPage}/>
        </Router>
    );
}

export default App;
